var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-card-title',[_vm._v(" Empresas ")]),_c('v-spacer'),(_vm.component.permission.Cadastrar)?_c('v-btn',{staticClass:"success mr-2 mt-6",on:{"click":() => {
        _vm.active_addDialog();
      }}},[_vm._v(" Adicionar")]):_vm._e()],1),_c('div',{staticClass:"alert"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }